var map = {
	"./add-circle.svg": 305,
	"./add-square.svg": 306,
	"./add-user.svg": 307,
	"./add.svg": 308,
	"./alert-circle.svg": 309,
	"./alert-octagon.svg": 310,
	"./alert-triangle.svg": 311,
	"./approve.svg": 312,
	"./back.svg": 313,
	"./bell.svg": 314,
	"./bell_s.svg": 315,
	"./calendar.svg": 316,
	"./campaign.svg": 317,
	"./chat.svg": 318,
	"./check.svg": 319,
	"./chevron-down.svg": 320,
	"./chevron-down_s.svg": 321,
	"./chevron-left.svg": 322,
	"./chevron-right.svg": 323,
	"./chevron-up.svg": 324,
	"./chevrons-down.svg": 325,
	"./chevrons-left.svg": 326,
	"./chevrons-right.svg": 327,
	"./chevrons-up.svg": 328,
	"./clock.svg": 329,
	"./clock_s.svg": 330,
	"./close.svg": 331,
	"./configuration.svg": 332,
	"./creativity.svg": 333,
	"./details-off.svg": 334,
	"./details.svg": 335,
	"./drag-drop.svg": 336,
	"./edit.svg": 337,
	"./email.svg": 338,
	"./emoticon.svg": 339,
	"./filters.svg": 340,
	"./folder.svg": 341,
	"./format.svg": 342,
	"./full-screen.svg": 343,
	"./help.svg": 344,
	"./image.svg": 345,
	"./info.svg": 346,
	"./link-horizontal.svg": 347,
	"./link-oblique.svg": 348,
	"./log-out.svg": 349,
	"./menu.svg": 350,
	"./more-horizontal.svg": 351,
	"./more-vertical.svg": 352,
	"./next.svg": 353,
	"./not-approve.svg": 354,
	"./notification.svg": 355,
	"./on.svg": 356,
	"./order.svg": 357,
	"./ownership.svg": 358,
	"./papaerclip.svg": 359,
	"./papaerclip_s.svg": 360,
	"./phases.svg": 361,
	"./play-circle.svg": 362,
	"./play.svg": 363,
	"./play_s.svg": 364,
	"./previous.svg": 365,
	"./profile.svg": 366,
	"./reduce.svg": 367,
	"./refresh.svg": 368,
	"./refresh_s.svg": 369,
	"./remove-circle.svg": 370,
	"./remove-square.svg": 371,
	"./remove-user.svg": 372,
	"./remove.svg": 373,
	"./search.svg": 374,
	"./send.svg": 375,
	"./send_s.svg": 376,
	"./settings.svg": 377,
	"./share.svg": 378,
	"./template.svg": 379,
	"./text-align-center.svg": 380,
	"./text-align-justify.svg": 381,
	"./text-align-left.svg": 382,
	"./text-align-right.svg": 383,
	"./text-bold.svg": 384,
	"./text-italic.svg": 385,
	"./text-type.svg": 386,
	"./text-underline.svg": 387,
	"./trash.svg": 388,
	"./upload-cloud.svg": 389,
	"./upload.svg": 390,
	"./watch.svg": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;